// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"50dfda44","348":"97257dd8","367":"d49e6917","737":"bab3d498","787":"23455a43","993":"ccb4c80c"}[chunkId] + ".chunk.js";
};